
export const SETUP = 'setup';
export const CLEAR = 'clear';
export const FETCH_COUNTRIES = 'fetch:countries';
export const FETCHING_COUNTRIES = 'fetching:countries';
export const SELECT_COUNTRY = 'select:country';
export const COMMIT_COUNTRY = 'commit:country';
export const DEFER_SELECT_COUNTRY = 'defer:select-country';

export const FETCH_STATES = 'fetch:states';
export const FETCHING_STATES = 'fetching:states';
export const SELECT_STATE = 'select:state';
export const COMMIT_STATE = 'commit:state';
export const DEFER_SELECT_STATE = 'defer:select-state';
export const CLEAR_STATE = 'clear:state';

export const FETCHING_CITIES = 'fetching:cities';
export const FETCH_CITIES = 'fetch:cities';
export const SELECT_CITY = 'select:city';
export const DEFER_SELECT_CITY = 'defer:select-city';
export const COMMIT_CITY = 'commit:city';
export const CLEAR_CITY = 'clear:city';

export const SELECT_DEFERRED = 'select:deferred';

export const FETCHING_CITY_CENTROID = 'fetching:city-centroid';
export const FETCH_CITY_CENTROID = 'fetch:city-centroid';
